// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3cZl3","additionalInfo":"AgreementModal_additionalInfo__1c0Xg"};